function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HelpCircle } from '@ori-ui/icons';
import { Box, FormControl, FormHelperText, Grid, TextField, Tooltip, styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { Controller } from 'react-hook-form';
import { Localization } from '../../Localization';
import { defaultTranslations } from '../../constants/defaultTranslations';
import { TranslationKey } from '../../models';
import { AdornmentIcon } from '../AdornmentIcon';
var StyledHelpCircle = styled(HelpCircle)(function(param) {
    var theme = param.theme;
    return {
        marginTop: '4px',
        fontSize: '24px',
        color: theme.palette.grey[300]
    };
});
export var TextFormFieldByConfig = function(props) {
    var getTestId = useTestId().getTestId;
    var name = props.name, label = props.label, value = props.value, tooltipText = props.tooltipText, autocomplete = props.autocomplete;
    var renderHelpTooltip = function() {
        return /*#__PURE__*/ _jsx(Tooltip, {
            "data-testid": getTestId("".concat(name, "-tooltip")),
            title: tooltipText !== null && tooltipText !== void 0 ? tooltipText : '',
            enterTouchDelay: 0,
            leaveTouchDelay: 5000,
            children: /*#__PURE__*/ _jsx(StyledHelpCircle, {})
        });
    };
    return /*#__PURE__*/ _jsx(Grid, {
        size: {
            xs: 12
        },
        children: /*#__PURE__*/ _jsx(Box, {
            children: /*#__PURE__*/ _jsx(Controller, {
                name: name,
                defaultValue: value !== null && value !== void 0 ? value : '',
                render: function(param) {
                    var field = param.field, fieldState = param.fieldState;
                    return /*#__PURE__*/ _jsxs(FormControl, {
                        fullWidth: true,
                        children: [
                            /*#__PURE__*/ _jsx(TextField, _object_spread({
                                autoFocus: true,
                                fullWidth: true,
                                type: "text",
                                label: label,
                                error: !!fieldState.error,
                                variant: "standard",
                                autoCapitalize: "off",
                                InputProps: {
                                    endAdornment: fieldState.error ? /*#__PURE__*/ _jsx(AdornmentIcon, {
                                        fieldState: fieldState,
                                        text: /*#__PURE__*/ _jsx(Localization, {
                                            defaultMessage: defaultTranslations.invalidLoginName,
                                            id: TranslationKey.invalidLoginName
                                        })
                                    }) : renderHelpTooltip(),
                                    inputProps: {
                                        'data-testid': getTestId("".concat(name, "-text-field")),
                                        autoComplete: autocomplete !== null && autocomplete !== void 0 ? autocomplete : 'off',
                                        sx: {
                                            marginTop: '4px',
                                            fontSize: '14px'
                                        }
                                    }
                                }
                            }, field)),
                            fieldState.error ? /*#__PURE__*/ _jsx(FormHelperText, {
                                error: true,
                                children: fieldState.error.message
                            }) : null
                        ]
                    });
                }
            })
        })
    });
};
